import React from "react";
import "./comments.css";
import { Link } from "react-router-dom";
import { Skeleton } from "@material-ui/lab";
import { connect } from "react-redux";
// import prof from "../assets/images/dummy_profile.jpg"

function CommentProfile({ className, rootData }) {
  return (
    <React.Fragment>
      <div className={`profile_blog flex items-center ${className}`}>
        <div className="profile_image h-12 w-12 mr-2">
          {rootData.userProfilePic ? (
            <Link to="/">
              <img
                src={rootData.userProfilePic}
                alt="prof"
                className="blog_profile rounded-full"
              />
            </Link>
          ) : (
            <Skeleton
              variant="circle"
              className="w-12 blog_profile"
              height={48}
            />
          )}
        </div>
        <div className="profile_details leading-4">
          <div className="profile_top">
            <Link to="/">
              <span className="mr-3 text-black">
                {rootData.fname} {rootData.lname}
              </span>
            </Link>
          </div>
          <div className="profile_bottom">
            {/* <span className="text-gray-500 text-xs">May 30</span> */}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return state;
};
export default connect(mapStateToProps)(CommentProfile);
